/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const CircleArrowOutUpLeft = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M2 8V2h6" }],
    ["path", { d: "m2 2 10 10" }],
    ["path", { d: "M12 2A10 10 0 1 1 2 12" }]
  ]
];

export { CircleArrowOutUpLeft as default };
//# sourceMappingURL=circle-arrow-out-up-left.js.map
